export const API_URL = process.env.REACT_APP_API_URL || 'http://escolaresnuevoingreso.ith.mx/api/api';
export const TOKEN = sessionStorage.getItem('token')